// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6077":"3bacb868d3409166","81753":"57c0ae4b8967c90f","86022":"8969fd31f3a473f3","88528":"2148c080928c6fd5"}[chunkId] + ".css";
};